// @flow
import { combineReducers } from 'redux';
import entries from './entries';
import selectedProduct from './selectedProduct';

export default combineReducers({
  entries,
  selectedProduct,
});
